import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
var moment = require("moment");
import KivaProxy from '@/utils/kivaProxy/src';
var requests = require("../utils/requests").default;
export default {
  data: function data() {
    return {
      // status: "stop",
      counter: {
        id: "te" + this.getUniqId(),
        time: 0,
        storage: 0,
        task: null,
        thread: null,
        record_id: null,
        isRunning: false,
        description: '',
        start: moment(),
        project: null,
        record_owner: null,
        account_name: null,
        section: null,
        subject: '',
        time_show: '00:00',
        uniq: '',
        draft: true
      },
      selectedTE: {},
      keyTable: 'keyTable',
      listAll: [],
      isTimeEntrySetted: 0 // to prevent loop
    };
  },

  computed: {
    isRunning: {
      get: function get() {
        return this.$store.state.tasks.counterIsRunning;
      },
      set: function set(val) {
        this.$store.state.tasks.counterIsRunning = val;
      }
    },
    toggleRunning: {
      get: function get() {
        return this.$store.state.tasks.toggleRunning;
      },
      set: function set(val) {
        this.$store.state.tasks.toggleRunning = val;
      }
    },
    status: {
      get: function get(val) {
        return this.$store.state.tasks.timeCounter.status;
      },
      set: function set(val) {
        this.$store.state.tasks.timeCounter.status = val;
      }
    },
    timeCounter: {
      get: function get(val) {
        return this.$store.state.tasks.timeCounter;
      },
      set: function set(val) {
        this.$store.state.tasks.timeCounter = val;
      }
    },
    timeCounterAll: {
      get: function get(val) {
        return this.$store.state.tasks.timeCounterAll;
      },
      set: function set(val) {
        this.$store.state.tasks.timeCounterAll = val;
      }
    },
    timeCounterUniq: {
      get: function get(val) {
        // return {uniq:''}
        return this.$store.state.tasks.timeCounter.uniq;
      },
      set: function set(val) {
        this.$store.state.tasks.timeCounter.uniq = val;
      }
    }
  },
  methods: {
    getUniqId: function getUniqId() {
      return new Date().getUTCHours() + "_" + new Date().getUTCDay() + new Date().getMinutes() + new Date().getUTCMilliseconds();
    },
    open: function open() {
      var area = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "timeEntry";
      var state = this.$store.state.app;
      state.drawer = true;
      state.activeDrawer.tab = area;
      state.activeDrawer.options = {};
    },
    showModal: function showModal(row) {
      // console.log("showModal",row)
      if (row.object_type == "TASK") {
        this.$store.state.tasks.popup.task = {
          record_id: row.record_id
        };
        this.$store.state.tasks.popup.show = true;
      } else if (row.object_type == "THREAD") {
        console.log("v", row);
        if (row.request_type == 2) {
          this.$store.dispatch("app/activateDrawer", {
            show: true,
            tab: "featureRequest",
            mode: 'all',
            options: {
              record_id: row.record_id,
              mode: 'all'
            }
          });
        } else {
          this.$store.state.app.templatePopup.data = _objectSpread(_objectSpread({}, row), {}, {
            model: "thread",
            openSearchBox: false
          });
          this.$store.state.app.templatePopup.show = true;
        }
      } else if (row.object_type == "EVENT") {
        console.log("event row ", row);
        this.$store.state.app.templatePopup.data = _objectSpread(_objectSpread({}, row), {}, {
          model: "event",
          openSearchBox: false
        });
        this.$store.state.app.templatePopup.show = true;
      }
    },
    getCounterFirstTime: function getCounterFirstTime() {
      var _this = this;
      var fromLocalStorage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return new Promise(function (resolve, reject) {
        // console.log("getCounterFirstTime")

        // if(this.timeCounter.checked && ( fromLocalStorage && this.timeCounter.time % 3 == 0 || !this.isRunning )){
        if (!_this.timeCounter.checked && fromLocalStorage && (_this.timeCounter.time % 3 == 0 || !_this.isRunning)) {
          var te = window.localStorage.getItem("timeCounter");
          if (te && te.charAt(0) == "{") {
            // console.log("started")
            var entry = JSON.parse(te);
            var m2 = moment(_this.timeCounter.start);
            var m1 = moment(entry.start);
            var diff = moment(m1).diff(m2, "seconds");
            // console.log("m1", m1)
            // console.log("m2",m2)
            // console.log("diff", diff, entry.start, this.timeCounter.start)
            _this.timeCounter = entry;
            if (_this.timeCounter.start && (typeof diff == "undefined" || diff >= 0)) {
              if (entry.isRunning != _this.isRunning) {
                _this.timeCounter.time = moment().diff(_this.timeCounter.start, "seconds") + _this.timeCounter.storage;
                _this.timeCounter.storage = _this.timeCounter.time;
                _this.timeCounter.start = moment();
                var willStart = _this.timeCounter.isRunning ? 'yes' : 'stop';
                _this.toggleRunning = willStart;
                _this.pushNewTimeEntryOnAll(_this.timeCounter);
              }
              // return entry 
              resolve(entry);
            }
          } else {
            _this.restartTime();
            _this.toggleTimer();
          }
        }
        // console.log("getCounterFirstTime outside")

        _this.pushNewTimeEntryOnAll(_this.timeCounterter);
        resolve(_this.timeCounter);
      });
    },
    getCounter: function getCounter() {
      var fromLocalStorage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.timeCounter.checked && fromLocalStorage && (this.timeCounter.time % 3 == 0 || !this.isRunning)) {
        var te = window.localStorage.getItem("timeCounter");
        if (te && te.charAt(0) == "{") {
          // console.log("started")
          var entry = JSON.parse(te);
          var m2 = moment(this.timeCounter.start);
          var m1 = moment(entry.start);
          var diff = moment(m1).diff(m2, "seconds");
          // console.log("m1",m1)
          // console.log("m2",m2)
          // console.log("diff",diff,entry.start,this.timeCounter.start )
          // uniq yani storage ve counteda işlem aynı olduğunda tümünün yenilenmesi sayfanın tamamının yenilmesine neden oluyor. 
          // Bunu engellemek için sadece ana değerler değişmişse onu değiştiriyoruz.
          if (this.timeCounter.uniq == entry.uniq && this.timeCounter.start == entry.start && this.timeCounter.isRunning == entry.isRunning) {} else {
            this.timeCounter = entry;
          }
          if (this.timeCounter.start && (typeof diff == "undefined" || diff >= 0)) {
            if (entry.isRunning != this.isRunning) {
              this.timeCounter.time = moment().diff(this.timeCounter.start, "seconds") + this.timeCounter.storage;
              this.timeCounter.storage = this.timeCounter.time;
              this.timeCounter.start = moment();
              var willStart = this.timeCounter.isRunning ? 'yes' : 'stop';
              this.toggleRunning = willStart;
            }
            return entry;
            // resolve(entry);
          }
        }
      }
      // this.pushNewTimeEntryOnAll(this.timeCounter);
      return this.timeCounter;
    },
    // FFA800
    setCounterFirstTime: function setCounterFirstTime() {
      if (!this.timeCounter.start) {
        this.timeCounter = this.counter;
      }
      var t = JSON.stringify(this.timeCounter);
      // console.log("setCounterFirstTime", t)
      window.localStorage.setItem("timeCounter", t);
      /// if any unexpected issue occurs when getting counter from  localStorage
      // this counter setted to prevent endless loop
      this.isTimeEntrySetted++;
      if (this.isTimeEntrySetted > 5) {
        this.isTimeEntrySetted = 0;
        return this.timeCounter;
      }
      //--

      this.getCounter(true);
    },
    setCounter: function setCounter(refresh) {
      // console.log("refresh",refresh,this.timeCounter)
      // eğer yenileme isteği varsa 
      // Burası pause sonrası çalışacak şekilde tasarlandı.
      if (refresh && this.timeCounter.checked) {
        // if counter is stopped or paused
        if (!this.timeCounter.isRunning) {
          this.isRunning = false;

          //if paused > set sorage value as time value
          this.timeCounter.storage = this.timeCounter.time;
        } else {
          // if counter is running
          var forceRunningLocalStorage = !refresh;
          this.getCounter(forceRunningLocalStorage);
          this.timeCounter.start = moment();
          this.timeCounter.storage = this.timeCounter.time;
          this.$store.state.tasks.counterIsRunning = true;
          // this.$store.state.tasks.timeCounter.isRunning = true;
        }
      }

      var tm = Math.ceil(this.timeCounter.time / 60);
      var h = Math.floor(tm / 60);
      var m = tm % 60;
      this.timeCounter.minutes = m;
      this.timeCounter.hours = h;
      this.timeCounter.time_show = moment("1900-01-01 00:00:00").add(this.timeCounter.time, "seconds").format("HH:mm:ss");
      if (refresh && this.timeCounter.checked) {
        var t = JSON.stringify(this.timeCounter);
        // console.log("setCounter", t)
        window.localStorage.setItem("timeCounter", t);
        this.saveTimeEntry(_objectSpread({}, this.timeCounter), {}, true);
        this.pushNewTimeEntryOnAll(this.timeCounter);
      }
    },
    incrementTime: function incrementTime() {
      this.getCounter(true);
      // console.log("incrementTime",this.timeCounter,this.isRunning)
      if (this.isRunning) {
        this.timeCounter.time = moment().diff(this.timeCounter.start, "seconds") + this.timeCounter.storage + 1;
        this.timeCounter.storage = this.timeCounter.storage ? this.timeCounter.storage : 0;
        this.setCounter(false);
      }
    },
    getTaskFieldsIntoCounter: function getTaskFieldsIntoCounter(task) {
      var record_id = task.record_id ? task.record_id : null;
      var object_type = task.object_type;
      var uniq = task.uniq;
      var task_id = object_type == 'TASK' ? task.record_id : null;
      var thread_id = object_type == 'THREAD' ? task.record_id : null;
      var event_id = object_type == 'EVENT' ? task.record_id : null;
      var project = {
        value: null,
        label: ''
      };
      if (task.project && task.project.value) {
        project = task.project;
      } else {
        project = {
          value: task.project || null,
          label: task.rel_project_label || ''
        };
      }
      var subject = task.subject;
      var rtn = {
        record_id: record_id,
        task: task_id,
        thread: thread_id,
        event: event_id,
        uniq: uniq,
        object_type: object_type,
        project: project,
        subject: subject
      };
      // console.log(rtn)
      if (typeof this.getTasksInProgress !== "undefined") {
        this.getTasksInProgress();
      } else {
        this.$emit('getTasksInProgress', true);
      }
      return rtn;
    },
    addToCounter: function addToCounter(data) {
      // console.log("addToCounter",data)
      var _this$getTaskFieldsIn = this.getTaskFieldsIntoCounter(data),
        record_id = _this$getTaskFieldsIn.record_id,
        id = _this$getTaskFieldsIn.id,
        task = _this$getTaskFieldsIn.task,
        thread = _this$getTaskFieldsIn.thread,
        uniq = _this$getTaskFieldsIn.uniq,
        event = _this$getTaskFieldsIn.event,
        project = _this$getTaskFieldsIn.project,
        object_type = _this$getTaskFieldsIn.object_type,
        subject = _this$getTaskFieldsIn.subject;
      this.timeCounter.record_id = record_id;
      this.timeCounter.task = task;
      this.timeCounter.event = event;
      this.timeCounter.thread = thread;
      this.timeCounter.uniq = uniq;
      this.timeCounter.project = project;
      this.timeCounter.object_type = object_type;
      this.timeCounter.subject = subject;
      this.timeCounter.id = id;
      this.setCounter(true);
    },
    removeTimer: function removeTimer() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var willRunning, counter;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              willRunning = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              counter = _arguments.length > 1 ? _arguments[1] : undefined;
              counter = counter ? counter : _this2.timeCounter;
              _this2.$confirm(_this2.$t("This will permanently delete the entry. Continue?"), _this2.$t("Warning"), {
                confirmButtonText: _this2.$t("Ok"),
                cancelButtonText: _this2.$t("Cancel"),
                type: "warning"
              }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _this2.removeTimeEntryOnAll(counter);
                      if (_this2.timeCounter.id && counter.id == _this2.timeCounter.id || _this2.timeCounter.record_id && counter.record_id == _this2.timeCounter.record_id) {
                        _this2.restartTime(willRunning);
                      }
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    renewTimer: function renewTimer() {
      var _arguments2 = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var willRunning, task, filters_Search;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              willRunning = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
              task = _arguments2.length > 1 ? _arguments2[1] : undefined;
              filters_Search = {
                draft: ["NOT EMPTY"]
              };
              filters_Search.record_owner = ["=", _objectSpread({}, _this3.$store.state.users.CURRENT_USER).userId];
              _context4.next = 6;
              return new KivaProxy({
                endpoint: 'act/time_entry'
              }).setFilters(filters_Search).all().then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data) {
                  var kk;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(data.success == true && data.records[0] && data.records[0].record_id)) {
                          _context3.next = 4;
                          break;
                        }
                        kk = data.records[0]; // await new KivaProxy({  endpoint: 'act/time_entry'  }).destroy(kk.record_id,{erase:1}).then(data => {});
                        _context3.next = 4;
                        return new KivaProxy({
                          endpoint: 'act/time_entry'
                        }).update({
                          draft: 1,
                          paused: true,
                          record_id: kk.record_id
                        }).then(function (data) {});
                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()).finally(function () {
                _this3.toggleTimer();
                _this3.restartTime(willRunning);
              });
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    deleteTimer: function deleteTimer(id) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return new KivaProxy({
                endpoint: 'act/time_entry'
              }).destroy(id, {
                erase: 1
              }).then(function (data) {});
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    continueTimeEntry: function continueTimeEntry(counter) {
      this.restartTime(true, counter);
    },
    restartTime: function restartTime() {
      var _arguments3 = arguments,
        _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var willRunning, counter, _this4$getTaskFieldsI, _task, _thread, event, uniq, project, object_type, subject, task, thread, willStart, t;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              willRunning = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : false;
              counter = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : null;
              _this4.visibleClose = false;
              if (counter && counter != null) {} else {
                _this4$getTaskFieldsI = _this4.getTaskFieldsIntoCounter(_this4.selectedTE), _task = _this4$getTaskFieldsI.task, _thread = _this4$getTaskFieldsI.thread, event = _this4$getTaskFieldsI.event, uniq = _this4$getTaskFieldsI.uniq, project = _this4$getTaskFieldsI.project, object_type = _this4$getTaskFieldsI.object_type, subject = _this4$getTaskFieldsI.subject;
                counter = {
                  id: "te" + _this4.getUniqId(),
                  time: 0,
                  storage: 0,
                  task: _task,
                  thread: _thread,
                  event: event,
                  isRunning: willRunning,
                  start: moment(),
                  // start: "2000-01-01T00:01:57.621Z",
                  checked: true,
                  description: '',
                  uniq: uniq,
                  project: project,
                  subject: subject,
                  object_type: object_type
                };
              }
              task = null;
              thread = null;
              if (willRunning) {
                // eğer zaten devam ediyorsa ve
                _this4.toggleTimer();
              }
              if (!task) {
                _context7.next = 12;
                break;
              }
              _context7.next = 10;
              return new KivaProxy({
                endpoint: 'act/task'
              }).update({
                task_status: 2,
                record_id: task
              }).then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data) {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (!(typeof _this4.getTasksInProgress !== "undefined")) {
                          _context6.next = 5;
                          break;
                        }
                        _context6.next = 3;
                        return _this4.getTasksInProgress();
                      case 3:
                        _context6.next = 6;
                        break;
                      case 5:
                        _this4.$emit('getTasksInProgress', true);
                      case 6:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()).catch(function (err) {});
            case 10:
              _context7.next = 15;
              break;
            case 12:
              if (!thread) {
                _context7.next = 15;
                break;
              }
              _context7.next = 15;
              return new KivaProxy({
                endpoint: 'inbox/thread'
              }).update({
                case_status: 5,
                record_id: thread
              }).then(function (data) {}).catch(function (err) {});
            case 15:
              // console.log("seetted", counter)
              Object.assign(_this4.timeCounter, counter);
              _this4.isRunning = willRunning;
              _this4.timeCounter.time_show = "00:00";

              // clearInterval(this.interval);  
              willStart = willRunning ? 'yes' : 'no';
              _this4.toggleRunning = willStart;
              t = JSON.stringify(counter);
              _this4.pushNewTimeEntryOnAll(counter);
              window.localStorage.setItem("timeCounter", t);
            case 23:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    removeTimeEntryOnAll: function removeTimeEntryOnAll(activeCOUNTER) {
      var tea = window.localStorage.getItem("timeCounterAll");
      var te = [];
      if (tea && tea.charAt(0) == "[") {
        te = JSON.parse(tea);
        te = te.filter(function (k) {
          return k && k.id != activeCOUNTER.id;
        });
        window.localStorage.setItem("timeCounterAll", JSON.stringify(te));
        this.timeCounterAll = te;
      }
    },
    saveTimeEntryOnAll: function saveTimeEntryOnAll(counter) {
      if (counter.id == this.timeCounter.id) {
        this.timeCounter.description = counter.description;
        var t = JSON.stringify(this.timeCounter);
        // console.log("4", t)
        window.localStorage.setItem("timeCounter", t);
      }
      this.pushNewTimeEntryOnAll(counter);
    },
    setFreeTimeEntryOnAll: function setFreeTimeEntryOnAll() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var te, filters_Search;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              te = [];
              window.localStorage.setItem("timeCounterAll", te);
              _this5.timeCounterAll = te;
              filters_Search = {
                draft: ["NOT EMPTY"]
              };
              filters_Search.record_owner = ["=", _objectSpread({}, _this5.$store.state.users.CURRENT_USER).userId];
              _context9.next = 7;
              return new KivaProxy({
                endpoint: 'act/time_entry'
              }).setFilters(filters_Search).all().then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(data) {
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (data.success == true && data.records[0] && data.records[0].record_id) {
                          data.records.forEach(function (k) {
                            //  console.log("k.record_id",k.record_id)
                            _this5.deleteTimer(k.record_id);
                          });
                        }
                      case 1:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 7:
              _this5.restartTime(false);
              // let t = JSON.stringify(this.timeCounter);
              // window.localStorage.setItem("timeCounter", t);
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    pushNewTimeEntryOnAll: function pushNewTimeEntryOnAll(newCounter) {
      // console.log("newCounter", newCounter)
      var tea = window.localStorage.getItem("timeCounterAll");
      var te = [];
      if (tea && tea.charAt(0) == "[") {
        var arr = JSON.parse(tea);
        var isInSide = false;
        arr.forEach(function (k) {
          if (newCounter && k && k.id == newCounter.id) {
            isInSide = true;
            te.push(_objectSpread({}, newCounter));
          } else {
            if (k) {
              te.push(k);
            }
          }
        });
        if (!isInSide && newCounter) {
          te.push(newCounter);
        }
      } else {
        if (newCounter) {
          te.push(newCounter);
        }
      }
      window.localStorage.setItem("timeCounterAll", JSON.stringify(te));
      this.timeCounterAll = te;
      return te;
    },
    setFree: function setFree() {
      var today = new Date();
      var start_date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      var id = "te" + this.getUniqId();
      this.mutatedData = {
        id: id,
        time: 0,
        hours: 0,
        minutes: 0,
        time_show: '00:00',
        task: null,
        thread: null,
        project: null,
        account_name: null,
        description: '',
        record_id: null,
        start_date: start_date,
        all_time_entries: [],
        record_owner: this.$store.state.users.CURRENT_USER.userId
      };
    },
    toggleTimer: function toggleTimer() {
      var forcedRunnig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "na";
      if (forcedRunnig == "stop" || forcedRunnig == "no" || forcedRunnig == "na" && this.timeCounter.isRunning) {
        this.isRunning = false;
        this.timeCounter.isRunning = false;
      } else if (forcedRunnig == "yes" || forcedRunnig == "na" && !this.timeCounter.isRunning) {
        this.isRunning = true;
        this.timeCounter.isRunning = true;
      }
      if (forcedRunnig != "stop") {
        this.setCounter(true);
      }
    },
    saveAndStop: function saveAndStop(counter) {
      counter = counter ? counter : this.timeCounter;
      if (counter && (counter.id || counter.record_id)) {
        this.showTimeForm(_objectSpread({}, counter));
      }
    },
    startNewTimeEntry: function startNewTimeEntry() {
      var _arguments4 = arguments,
        _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var start, task;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              start = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : false;
              task = _arguments4.length > 1 ? _arguments4[1] : undefined;
              // var olan time entry pause olacak.
              // yeni counter başlatılacak.
              if (_this6.isRunning) {
                _this6.toggleTimer();
              }
              _this6.selectedTE = task;
              _this6.restartTime(start);
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    saveTimeEntry: function saveTimeEntry(params, xdata) {
      var _arguments5 = arguments,
        _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var isDraft, setData, r, update, filters_Search, any, filters;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              isDraft = _arguments5.length > 2 && _arguments5[2] !== undefined ? _arguments5[2] : false;
              if (!params) {
                params = _this7.getCounter();
              }
              if (!xdata) {
                xdata = _this7.data;
              }
              if (!(params.record_id && params.record_id != null || params.project || params.description)) {
                _context12.next = 36;
                break;
              }
              setData = params;
              setData.draft = null;
              if (isDraft) {
                setData.draft = 1;
              }
              // console.log(this.data)
              if (!setData.start_date) {
                setData.start_date = moment().format("YYYY-MM-DD");
              }
              setData.paused = params.isRunning;
              setData.seconds = params.time % 60;
              setData.minutes = Math.floor(params.time / 60) % 60;
              setData.hours = Math.floor(params.time / 60 / 60);
              setData.account_name = params.account_name && params.account_name.value ? params.account_name.value : params.account_name ? params.account_name : null;
              setData.project = params.project && params.project.value ? params.project.value : params.project ? params.project : null;
              setData.section = params.section && params.section.value ? params.section.value : params.section ? params.section : null;
              setData.record_owner = params.record_owner && params.record_owner.value ? params.record_owner.value : _this7.$store.state.users.CURRENT_USER ? _this7.$store.state.users.CURRENT_USER.userId : null;
              if (!setData.record_owner) {
                _context12.next = 36;
                break;
              }
              delete setData.record_id;
              r = false;
              update = null;
              filters_Search = {
                draft: ["NOT EMPTY"]
              };
              any = false;
              if (setData.thread == null) {} else {
                filters_Search.thread = ["!=", setData.thread];
                any = true;
              }
              if (setData.task == null) {} else {
                filters_Search.task = ["!=", setData.task];
                any = true;
              }
              if (setData.event == null) {} else {
                filters_Search.event = ["!=", setData.event];
                any = true;
              }
              if (any == false) {
                filters_Search.task = ["EMPTY"];
                filters_Search.thread = ["EMPTY"];
                filters_Search.event = ["EMPTY"];
              }
              filters_Search.record_owner = ["=", _this7.$store.state.users.CURRENT_USER.userId];
              filters_Search.duration = [">", 0];
              if (!(params.time > 0 && any)) {
                _context12.next = 31;
                break;
              }
              _context12.next = 31;
              return new KivaProxy({
                endpoint: 'act/time_entry'
              }).setFilters(filters_Search).all().then(function (data) {
                if (data.success == true) {
                  data.records.forEach( /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(kk) {
                      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                        while (1) switch (_context11.prev = _context11.next) {
                          case 0:
                            _context11.next = 2;
                            return new KivaProxy({
                              endpoint: 'act/time_entry'
                            }).update({
                              draft: null,
                              record_id: kk.record_id
                            }).then(function (data) {});
                          case 2:
                          case "end":
                            return _context11.stop();
                        }
                      }, _callee11);
                    }));
                    return function (_x4) {
                      return _ref5.apply(this, arguments);
                    };
                  }());
                }
              });
            case 31:
              filters = {
                draft: ["NOT EMPTY"]
              };
              filters.record_owner = ["=", _this7.$store.state.users.CURRENT_USER.userId];

              // if(setData.thread==null){
              //   filters.thread=["EMPTY"]
              // }else{
              //   filters.thread=["=",setData.thread]
              // }
              // if(setData.task==null){
              //   filters.task=["EMPTY"]
              // }else{
              //   filters.task=["=",setData.task]
              // } 
              // if(setData.event==null){
              //   filters.event=["EMPTY"]
              // }else{
              //   filters.event=["=",setData.event]
              // }

              // task:["=",setData.task]
              _context12.next = 35;
              return new KivaProxy({
                endpoint: 'act/time_entry'
              }).setFilters(filters).all()
              // .setFilters({draft:["=",1],event:["=",setData.event],thread:["=",setData.thread],task:["=",setData.task]}).all()
              .then(function (response) {
                setData.record_id = response.records[0] ? response.records[0].record_id : null;
                if (setData.record_id == null) {
                  delete setData.record_id;
                }

                // SADECE UPDATE OLMALI -- CREATE AŞAĞIDA BİR YERDE YER ALMALI ?
                var method = setData.record_id ? 'update' : 'create';
                if (isDraft || !isDraft && params.time > 0) {
                  new KivaProxy({
                    endpoint: 'act/time_entry'
                  })[method](setData).then(function (data) {
                    if (data.success == true) {
                      r = true;
                      _this7.setFree();

                      // console.log("saveTimeEntry 2") 
                    }
                  }).catch(function (err) {
                    console.log(err);
                  });
                } else {
                  // console.log("0 data")
                }
              });
            case 35:
              if (!isDraft && params.time > 0) {
                _this7.restartTime(false);
              }
            case 36:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    getActiveTimeEntry: function getActiveTimeEntry(_ref6) {
      var _this8 = this;
      var commit = _ref6.commit;
      return new Promise(function (resolve, reject) {
        new KivaProxy({
          endpoint: 'act/time_entry'
        }).setFilters({
          record_owner: smartFilter.owner ? smartFilter.owner[0] : null,
          draft: ["NOT EMPTY"]
        }).all().then(function (response) {
          _this8.TIME_ENTRIES = response.records;
        }).catch(reject);
      });
    },
    createTimeEntry: function createTimeEntry(data) {
      var _arguments6 = arguments,
        _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var task, willStartNew, type, rtn, text, tea, te, _tea, _te, state;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              task = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : {};
              willStartNew = _arguments6.length > 2 && _arguments6[2] !== undefined ? _arguments6[2] : false;
              _this9.saving = true;
              type = task && task.object_type ? task.object_type : "TASK";
              if (!data.record_owner) {
                data.record_owner = _this9.$store.state.users.CURRENT_USER.userId;
              }
              _context13.next = 7;
              return requests.save_time_entry({
                data: _objectSpread({}, data),
                task: _objectSpread({}, task)
              });
            case 7:
              rtn = _context13.sent;
              text = "";
              if (rtn && rtn.status == "Success") {
                if (rtn.text) {
                  text = rtn.text;
                } else {
                  text = "Time entry  successfully saved.";
                }

                // remove time entry from list 
                if (data && data.id) {
                  tea = window.localStorage.getItem("timeCounterAll");
                  te = [];
                  if (tea && tea.charAt(0) == "[") {
                    te = JSON.parse(tea);
                    te = te.filter(function (k) {
                      return k && k.id != data.id;
                    });
                    window.localStorage.setItem("timeCounterAll", JSON.stringify(te));
                    _this9.timeCounterAll = te;
                  }
                  // console.log("1",data,this.timeCounter)
                  if (data.id == _this9.timeCounter.id) {
                    _this9.restartTime(willStartNew);
                  }
                } else if (data && data.record_id) {
                  _tea = window.localStorage.getItem("timeCounterAll");
                  _te = [];
                  if (_tea && _tea.charAt(0) == "[") {
                    _te = JSON.parse(_tea);
                    _te = _te.filter(function (k) {
                      return k && k.record_id != data.record_id;
                    });
                    window.localStorage.setItem("timeCounterAll", JSON.stringify(_te));
                    _this9.timeCounterAll = _te;
                  }
                  // console.log("2",data,this.timeCounter)

                  if (data.record_id == _this9.timeCounter.record_id) {
                    _this9.restartTime(willStartNew);
                  }
                }
                state = _this9.$store.state.app;
                state.drawer = true;
                state.activeDrawer.tab = 'timeEntry';
                state.activeDrawer.options = {};
                _this9.$store.state.lastUpdate = {
                  app: "act",
                  model: "time_entry",
                  id: data.id ? data.id : data.record_id ? data.record_id : '',
                  work: "create",
                  time: moment().valueOf(),
                  data: _this9.data
                };
                _this9.$store.state.lastUpdate.time = moment().valueOf();
              } else {
                if (rtn.text) {
                  text = rtn.text;
                  if (rtn.err) {
                    text = text + rtn.err;
                  }
                } else {
                  text = "Zaman girişi kaydedilirken hata oluştu.";
                }
                _this9.$store.state.response_alert = {
                  name: "Kullanıcı",
                  title: _this9.$t("Christ no!"),
                  text: text,
                  status: true,
                  modal: true,
                  class: "warning"
                };
              }
              _this9.saving = false;
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    getAllWaitingEntries: function getAllWaitingEntries(search) {
      var tea = window.localStorage.getItem("timeCounterAll");
      var te = [];
      if (tea && tea.charAt(0) == "[") {
        te = JSON.parse(tea);
      }
      this.keyTable = "k" + Math.random(11, 999999);
      this.listAll = te;
      return te;
    },
    showTimeForm: function showTimeForm() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var tc = this.timeCounter;
      // console.log("tc",data,tc)
      if (data.id && data.id == tc.id || data.record_id && data.record_id == tc.record_id) {
        this.toggleTimer();
        this.toggleTimer();
      }
      var state = this.$store.state.app;
      state.drawer = true;
      state.activeDrawer.tab = "logTimeEntry";
      state.activeDrawer.options = {
        data: data
      };
    },
    startDrawer: function startDrawer(status) {
      if (status != "new") {
        var tm = Math.ceil(this.counter.time / 60);
        var h = Math.floor(tm / 60);
        var m = tm % 60;
        this.$store.state.tasks.timeCounter = {
          time: this.counter.time,
          minutes: m,
          hours: h,
          task: this.counter.task,
          thread: this.counter.thread,
          status: 'stop'
        };
        // clearInterval(this.interval);
        this.status = "stop";
        this.counter.isRunning = false;
        this.setCounter(true);
      } else {
        this.$store.state.tasks.timeCounter = {
          time: 0,
          minutes: 0,
          hours: 0,
          task: this.task_id,
          thread: this.thread_id,
          status: 'play'
        };
      }
      this.drawer = true;
    },
    deleteEntry: function deleteEntry(row) {
      var _this10 = this;
      this.$confirm(this.$t("This will permanently delete the entry. Continue?"), this.$t("Warning"), {
        confirmButtonText: this.$t("Ok"),
        cancelButtonText: this.$t("Cancel"),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return new KivaProxy({
                endpoint: "act/time_entry"
              }).destroy(row.record_id, {
                erase: 1
              }).then(function (response) {
                _this10.starter();
                _this10.$message({
                  type: "success",
                  message: _this10.$t("Delete completed")
                });
                _this10.$store.state.lastUpdate = {
                  app: "act",
                  model: "time_entry",
                  id: row.record_id,
                  work: "delete",
                  time: moment().valueOf(),
                  data: _this10.row
                };
                _this10.$store.state.lastUpdate.time = moment().valueOf();
              }).catch(function () {
                _this10.$message({
                  type: "info",
                  message: _this10.$t("Delete canceled")
                });
              });
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))).catch(function () {
        _this10.$message({
          type: "info",
          message: _this10.$t("Delete canceled")
        });
      });
    },
    showTime: function showTime(time) {
      return moment("1900-01-01 00:00:00").add(time, "seconds").format("HH:mm:ss");
    }
  }
};